import { IComponentOptions } from "angular";
import { MachineDetailConfigurationsMoveController } from "./controller";

export const vsComponentName = "machineDetailConfigurationsMove";

export const MachineDetailConfigurationsMoveComponentOptions: IComponentOptions =
  {
    controller: MachineDetailConfigurationsMoveController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "componentController",
    bindings: {
      machine: "<",
    },
  };
